import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import rrdefs from '../../../test/rrdefs'


const initialState = []
// const initialState = rrdefs


export default function appReducer(state = initialState, action) {
  // console.log("----action----", action)
  switch (action.type) {
    case types.ADD_ROUTING_RULE: {
      return [
        ...state,
        action.payload
      ]
    }

    case types.EDIT_ROUTING_RULE: {
      return [...state.map(rrdef => rrdef.id == action.payload.id ? (action.payload) : ({ ...rrdef }))]
    }

    case types.DELETE_ROUTING_RULE: {
      return state.filter(rrdef => rrdef.id !== action.payload.id)
    }

    case types.UPDATE_FULL_ROUTING_RULES: {
      return [
        ...state,
        ...action.payload
      ]
    }

    case types.RESET_ROUTING_RULES: {
      return [
        // ...state,
        ...action.payload
      ]
    }

    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);

    default:
      return state;
  }
}